import { useEffect } from 'react';

export function DebugRecaptcha() {
  useEffect(() => {
    console.log('[DEBUG] VITE_RECAPTCHA_SITE_KEY:', import.meta.env.VITE_RECAPTCHA_SITE_KEY);
    console.log('[DEBUG] NODE_ENV:', import.meta.env.MODE);
  }, []);

  return null; // This component doesn't render anything
}
